module.exports = __webpack_public_path__ + "img/default_icon.0c72bf75.png";